import React from 'react';
import { Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper
}
from '@mui/material';
import { stateList } from '../../../common/StaticFieldList';
import { CustomTableCell } from '../../../common/CustomTableCell';

const PolicyDriverDetails = ({driver_id, driverModel, setDriverModel}) => {

    const poppinsFont = {
        fontFamily: '"Poppins", sans-serif',
    };

    const formatDate = (dateString) => {
  if (!dateString) return "-";
  const parts = dateString.split("-");
  if (parts.length !== 3) return dateString;
  return `${parts[1]}-${parts[2]}-${parts[0]}`;
};

const getStateName = (code) => {
  if (!code) return "-";
  const state = stateList.find((s) => s.value === code);
  return state ? state.label : code;
};

    return(
        <>
            <Dialog maxWidth="lg" fullWidth open={driverModel} onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setDriverModel(false); }} disableScrollLock={true} keepMounted={false} hideBackdrop={false} style={{ zIndex: 1300 }}>
                <DialogTitle>Driver Details</DialogTitle>
                    <DialogContent>
                        <TableContainer sx={{ marginTop:'15px', verticalAlign: 'Top', boxShadow: 'none',}} component={Paper}>
                            <Table sx={{ verticalAlign: 'Top' }}>
                                <TableBody>
                                    <TableRow sx={{ verticalAlign: 'Top' }}>
                                        <TableCell>
                                            <Table>
                                                <TableRow>
                                                    <TableCell sx={poppinsFont}>
                                                        <strong>First Name:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.firstName}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="lastname" sx={poppinsFont}>
                                                        <strong>Last Name:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.lastName}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="dateofBirth" sx={poppinsFont}>
                                                        <strong>Date of Birth:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{formatDate(driver_id.dateOfBirth)}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="gender" sx={poppinsFont}>
                                                        <strong>Gender:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.gender}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="email" sx={poppinsFont}>
                                                        <strong>Marital Status:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.maritalStatus}</TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableCell>
                                        <TableCell>
                                            <Table>
                                                <TableRow>
                                                    <TableCell id="address" sx={poppinsFont}>
                                                        <strong>Relationship To Insured:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.relationshipToPolicyholder}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="zip" sx={poppinsFont}>
                                                        <strong>License State:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{getStateName(driver_id.driversLicenseState)}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="city" sx={poppinsFont}>
                                                        <strong>License Number:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.driversLicenseNumber}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="state" sx={poppinsFont}>
                                                        <strong>Email:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.email}</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell id="ownedrented" sx={poppinsFont}>
                                                        <strong>Student Type:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.studentType}</TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableCell>

                                        <TableCell>
                                            <Table>
                                                 <TableRow>
                                                    <TableCell id="createdby" sx={poppinsFont}>
                                                        <strong>Created By:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.createdBy?.name}</TableCell>
                                                </TableRow>
                                                 <TableRow>
                                                    <TableCell id="updatedBy" sx={poppinsFont}>
                                                        <strong>Updated By:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.updatedBy?.name}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="createdat" sx={poppinsFont}>
                                                        <strong>Created At:</strong>
                                                    </TableCell>

                                                     <CustomTableCell timestamp={driver_id.createdBy?.timestamp} />
                                                </TableRow>
                                                  <TableRow>
                                                    <TableCell id="updatedat" sx={poppinsFont}>
                                                        <strong>Updated At:</strong>
                                                    </TableCell>

                                                     <CustomTableCell timestamp={driver_id.updatedBy?.timestamp} />
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell id="ownedrented" sx={poppinsFont}>
                                                        <strong>Status:</strong>
                                                    </TableCell>
                                                    <TableCell sx={poppinsFont}>{driver_id.status}</TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setDriverModel(false)} >Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PolicyDriverDetails;